import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import AddCourseForm from "../Forms/AddCourseForm";
class CreateCourse extends React.Component {
  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="lg">
        <ModalHeader toggle={this.props.toggle}>
          {this.props.updateCourse === null ? (
            <div>
              <span className="fa-solid fa-circle-plus" /> Lägg till kurs
            </div>
          ) : (
            <div>
              <span className="fa-solid fa-pen-to-square" /> Redigera kurs:{" "}
              {this.props.updateCourse.name}
            </div>
          )}
        </ModalHeader>
        <ModalBody>
          <AddCourseForm
            updateCourse={this.props.updateCourse}
            refreshList={this.props.refreshList}
            dismissModal={this.props.toggle}
            toggleExpand={this.props.toggleExpand}
            isExpanded={this.props.isExpanded}
            availableProgramLicenses={this.props.availableProgramLicenses}
            selectedProgramLicenses={[]}
            handleToggleCourseAsLoading={this.props.handleToggleCourseAsLoading}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default CreateCourse;
